import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginationFilterRequest, PaginatedSelectModel } from "@/models/core.model";
import { AssignClubOwner, RunningClub, RunningClubList, RunningClubPaginationFilterRequest, UpsertRunningClub } from '@/models/running-club.model';

export const getPagedRunningClubs = async (input: RunningClubPaginationFilterRequest): Promise<PagedResponseModel<RunningClubList>> => {
  return await getReq(createUrl("a/RunningClub/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getRunningClubsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedRunningClubs(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${itm.name} (${itm.city.name})`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getRunningClub = async (id: number): Promise<BaseResponseModel<RunningClub>> => {
  return await getReq(createUrl(`a/RunningClub/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertRunningClub = async (input: UpsertRunningClub): Promise<BaseResponseModel<RunningClub>> => {
  return await postReq(createUrl("a/RunningClub/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const assignClubOwner = async (input: AssignClubOwner): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/RunningClub/AssignOwner"),
    input
  ).then((res: any) => res.data);
};

export const rotateClubJoinKey = async (id: number): Promise<BaseResponseModel<string>> => {
  return await postReq(createUrl(`a/RunningClub/RotateJoinKey/${id}`),
    {}
  ).then((res: any) => res.data);
};

/**
 * Club lookup scoped to where an activity happened. The API filters by city; it has no
 * country filter, so with only a country each page is narrowed client-side by the club's city.
 */
export const getRunningClubsLookupByLocation = async (
  input?: string, page?: number, cityId?: number, countryId?: number
): Promise<PaginatedSelectModel> => {
  const model: RunningClubPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: true,
    orderBy: 'Name',
    cityId,
  };
  return await getPagedRunningClubs(model).then(data =>
    ({
      data: data.result
        .filter(itm => cityId != null || countryId == null || itm.city?.countryId == countryId)
        .map(itm => ({
          value: itm.id,
          label: `${itm.name} (${itm.city.name})`
        })),
      isLastPage: data.pageNumber >= data.totalPages,
    })
  );
};
